<div class="container successo-prenotazione">
  <div class="row">
    <div class="col-12 d-flex flex-column align-items-center">
      <!-- <img
        src="./assets/images/flusso_prenotazione/success-payment.png"
        alt="successo prenotazione"
        class="img-fluid"
      /> -->

      <svg
        *ngIf="!showError"
        class="mb-5"
        width="82"
        height="82"
        viewBox="0 0 82 82"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M80.9999 41C80.9999 48.8955 78.6562 56.5737 74.2226 63.2052C73.6202 64.1067 72.6302 64.5938 71.6219 64.5938C71.025 64.5938 70.4213 64.4235 69.8879 64.0664C68.4529 63.1075 68.0678 61.1666 69.0267 59.7317C72.7712 54.1317 74.7499 47.6547 74.7499 41C74.7499 38.1405 74.3923 35.3005 73.6867 32.5601C73.2564 30.8889 74.2629 29.1848 75.934 28.7545C77.6064 28.3248 79.3092 29.3307 79.7395 31.0018C80.5757 34.2513 80.9999 37.615 80.9999 41ZM58.4584 69.8898C53.2094 73.0691 47.1724 74.75 41 74.75C22.3904 74.75 7.24999 59.6096 7.24999 41C7.24999 22.3904 22.3904 7.25 41 7.25C47.8902 7.25 54.5156 9.31177 60.1607 13.2125C61.5804 14.1934 63.5268 13.8375 64.5082 12.4178C65.4891 10.9982 65.1339 9.05176 63.7136 8.07031C57.0192 3.44507 49.1652 1 41 1C30.3158 1 20.2706 5.16077 12.7157 12.7157C5.16076 20.2706 1 30.3158 1 41C1 51.6842 5.16076 61.7294 12.7157 69.2843C20.2706 76.8392 30.3158 81 41 81C48.3144 81 55.4714 79.0066 61.697 75.2352C63.1734 74.3411 63.6452 72.4197 62.751 70.9432C61.8563 69.4668 59.9349 68.9956 58.4584 69.8898ZM41.3015 50.0613C40.8065 50.0808 40.3444 49.905 39.9856 49.5632L23.619 34.045C22.3666 32.8573 20.3884 32.9098 19.2013 34.1622C18.0135 35.4147 18.066 37.3928 19.3185 38.58L35.682 54.0957C37.1932 55.5325 39.1482 56.3125 41.2197 56.3125C41.3308 56.3125 41.4419 56.3101 41.5529 56.3058C43.7472 56.2173 45.7625 55.2676 47.2274 53.6312C47.2646 53.5903 47.3 53.5482 47.3348 53.5049L80.3102 12.4893C81.3918 11.144 81.1781 9.17688 79.8329 8.09595C78.4883 7.0144 76.5206 7.22803 75.439 8.57324L42.5283 49.5089C42.2048 49.8464 41.7714 50.0424 41.3015 50.0613Z"
          fill="url(#paint0_linear_121_1906)"
          stroke="url(#paint1_linear_121_1906)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_121_1906"
            x1="13.4808"
            y1="3.66617"
            x2="67.2308"
            y2="79.9162"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F7257D" />
            <stop offset="1" stop-color="#4373EE" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_121_1906"
            x1="13.4808"
            y1="3.66617"
            x2="67.2308"
            y2="79.9162"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F7257D" />
            <stop offset="1" stop-color="#4373EE" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        *ngIf="showError"
        xmlns="http://www.w3.org/2000/svg"
        class="warning-icon mb-5"
        viewBox="0 0 512 512"
        fill="#f7257d"
      >
        <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
        <path
          d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
        />
      </svg>

      <h1 class="do3-fw700" [ngClass]="showError ? 'mb-5' : ''">
        {{
          storedAppointment
            ? "La visita è stata prenotata!"
            : showError
            ? "Qualcosa è andato storto"
            : storedProductType + " è stato attivato"
        }}
      </h1>
      <p class="mb-5" *ngIf="!showError">
        A breve riceverai un'email di conferma dal nostro
        <strong>Health Manager</strong>.
      </p>

      <div class="mb-5" *ngIf="storedAppointment">
        <div class="d-flex align-items-center mb-3">
          <svg
            class="me-3"
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 1.00278C0 0.73683 0.10565 0.481767 0.293709 0.293709C0.481767 0.10565 0.73683 0 1.00278 0H2.46551C2.73147 3.96304e-09 2.98653 0.10565 3.17459 0.293709C3.36265 0.481767 3.4683 0.73683 3.4683 1.00278C3.4683 1.26874 3.36265 1.5238 3.17459 1.71186C2.98653 1.89992 2.73147 2.00557 2.46551 2.00557H2.00557V5.80813C1.99673 6.24715 2.07557 6.68351 2.23747 7.09169C2.39936 7.49986 2.64106 7.87163 2.94842 8.18523C3.25577 8.49884 3.62261 8.74797 4.02744 8.91805C4.43227 9.08813 4.86696 9.17573 5.30607 9.17573C5.74517 9.17573 6.17987 9.08813 6.5847 8.91805C6.98953 8.74797 7.35636 8.49884 7.66372 8.18523C7.97107 7.87163 8.21277 7.49986 8.37467 7.09169C8.53657 6.68351 8.6154 6.24715 8.60657 5.80813V2.00557H8.14796C7.882 2.00557 7.62694 1.89992 7.43888 1.71186C7.25082 1.5238 7.14517 1.26874 7.14517 1.00278C7.14517 0.73683 7.25082 0.481767 7.43888 0.293709C7.62694 0.10565 7.882 0 8.14796 0H9.60935C9.87531 0 10.1304 0.10565 10.3184 0.293709C10.5065 0.481767 10.6121 0.73683 10.6121 1.00278V5.80813C10.6122 7.02701 10.1929 8.20879 9.42445 9.15495C8.65603 10.1011 7.5854 10.754 6.39242 11.0039V11.7687C6.39242 12.2864 6.49439 12.799 6.69251 13.2773C6.89062 13.7556 7.18101 14.1902 7.54709 14.5563C7.91316 14.9224 8.34775 15.2128 8.82605 15.4109C9.30435 15.609 9.81699 15.711 10.3347 15.711C10.8524 15.711 11.365 15.609 11.8433 15.4109C12.3216 15.2128 12.7562 14.9224 13.1223 14.5563C13.4884 14.1902 13.7788 13.7556 13.9769 13.2773C14.175 12.799 14.277 12.2864 14.277 11.7687V8.19074C13.5191 7.95281 12.8714 7.45153 12.451 6.77757C12.0306 6.10361 11.8652 5.30146 11.9848 4.51617C12.1043 3.73088 12.501 3.01429 13.1029 2.49601C13.7049 1.97772 14.4724 1.69194 15.2668 1.69035C16.0611 1.68876 16.8298 1.97147 17.4338 2.48735C18.0379 3.00322 18.4373 3.71821 18.5601 4.50302C18.6828 5.28782 18.5206 6.09063 18.1029 6.76627C17.6852 7.44191 17.0395 7.94577 16.2825 8.18673V11.7687C16.2825 13.3461 15.6559 14.859 14.5405 15.9744C13.425 17.0899 11.9122 17.7165 10.3347 17.7165C8.75723 17.7165 7.24437 17.0899 6.12893 15.9744C5.0135 14.859 4.38685 13.3461 4.38685 11.7687V11.0346C3.15793 10.8181 2.04459 10.1755 1.24234 9.21967C0.440099 8.26387 0.00023711 7.05599 0 5.80813V1.00278Z"
              fill="#4A4A4A"
            />
          </svg>

          <div>
            <p>
              Dr. {{ doctorFromStore?.firstName }}
              {{ doctorFromStore?.lastName }}
            </p>
            <span>{{ doctorFromStore?.specializations[0].description }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <svg
            class="me-3"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.97857 1.32857C5.97857 0.976212 5.8386 0.638285 5.58944 0.38913C5.34029 0.139974 5.00236 0 4.65 0C4.29764 0 3.95971 0.139974 3.71056 0.38913C3.4614 0.638285 3.32143 0.976212 3.32143 1.32857V2.65714H1.99286C1.46432 2.65714 0.957428 2.8671 0.583694 3.24084C0.209961 3.61457 0 4.12146 0 4.65L0 6.64286H18.6V4.65C18.6 4.12146 18.39 3.61457 18.0163 3.24084C17.6426 2.8671 17.1357 2.65714 16.6071 2.65714H15.2786V1.32857C15.2786 0.976212 15.1386 0.638285 14.8894 0.38913C14.6403 0.139974 14.3024 0 13.95 0C13.5976 0 13.2597 0.139974 13.0106 0.38913C12.7614 0.638285 12.6214 0.976212 12.6214 1.32857V2.65714H5.97857V1.32857ZM18.6 8.30357H0V16.6071C0 17.1357 0.209961 17.6426 0.583694 18.0163C0.957428 18.39 1.46432 18.6 1.99286 18.6H16.6071C17.1357 18.6 17.6426 18.39 18.0163 18.0163C18.39 17.6426 18.6 17.1357 18.6 16.6071V8.30357Z"
              fill="#4A4A4A"
            />
          </svg>

          <p class="do3-fw700 do3-lightblue-text">
            {{ formattedDate }}
          </p>
        </div>
      </div>

      <button
        class="do3-secondary-btn drfeel-bg fs-5 do3-fw700 text-uppercase mx-auto"
        (click)="goToApp()"
      >
        Vai all'App
      </button>
    </div>
  </div>
</div>
